module.exports = __webpack_public_path__ + "img/61800.5c71fd1c.jpg";